import { useState } from 'react';
import SearchInput from '@rossum/components/search-input/SearchInput';
import { FilterComponentProps } from '../types';
import { FilterComponentWrapper } from './FilterComponentWrapper';
import { SelectOptionsSkeleton } from './SelectComponents';
import { useFilterSelectProps } from './useFilterSelectProps';

export const FilterSelect = <T extends string | number | undefined>({
  filterKey,
  name,
  options,
  currentValue,
  confirmFilter,
  onBackClick,
  onClose,
  optionsAreLoading,
  getOptionLabel = o => o,
}: FilterComponentProps<T>) => {
  const [searchValue, setSearchValue] = useState<string>('');

  const { ListComponent, selectedValues } = useFilterSelectProps({
    searchValue,
    options,
    currentValues: currentValue ? [currentValue?.toString()] : [],
    getOptionLabel,
    isSingleSelect: true,
  });

  return (
    <FilterComponentWrapper
      filterKey={filterKey}
      name={name}
      onSubmit={() => {
        const value = selectedValues[0];
        if (value) {
          confirmFilter(value as T);
          onClose();
        }
      }}
      onBackClick={onBackClick}
      onClose={onClose}
      isSubmitDisabled={!!optionsAreLoading}
      dataCy="filter-select"
    >
      <SearchInput
        onChange={setSearchValue}
        value={searchValue}
        withStartAdornment={false}
        sx={{ width: '100%' }}
      />
      {optionsAreLoading ? <SelectOptionsSkeleton /> : ListComponent}
    </FilterComponentWrapper>
  );
};
